module.exports = __webpack_public_path__ + "media/images/logo-8033779aa81f6269456c1e3bf6bd5a56.png";